<div #datepicker class="wfm-date-picker">
  <!-- Regular Datepicker input -->
  <div [ngClass]="valueInputClasses" *ngIf="!rangeMode">
    <button
      [attr.aria-controls]="'date-picker-' + id"
      [disabled]="disabled"
      aria-haspopup="true"
      type="button"
      class="button button--icon button--icon-transparent date-picker__calendar-icon-container"
      (mousedown)="mousedown()"
      (click)="calendarIconClick($event)"
    >
      <div class="date-picker__calendar-icon" [ngClass]="{ 'date-picker__calendar-icon--disabled': disabled }">
        <svg-icon
          name="ico-calendar-16"
          [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
          [ngStyle]="{ height: '16px' }"
        >
        </svg-icon>
      </div>
    </button>
    <input
      type="text"
      [placeholder]="placeholder || format"
      class="textbox"
      [class.date-picker__active-input]="inputMode === inputModes.value && !inline"
      [attr.name]="'datepicker-' + id"
      [disabled]="disabled"
      [attr.aria-invalid]="error"
      [(ngModel)]="input"
      (ngModelChange)="parseValue()"
      (blur)="parseInput()"
      (keyup.enter)="parseInput()"
    />
  </div>

  <!-- Range Datepicker inputs -->
  <div [ngClass]="rangeContainerClasses" *ngIf="rangeMode" [class.date-picker__range-inline]="inline">
    <div [ngClass]="rangeStartClasses" [class.date-picker__fixed-width]="inline">
      <!-- Label goes here-->
      <ng-container *ngIf="startDateLabel">
        <span class="text-14">
          {{ startDateLabel | translate }}
        </span>
      </ng-container>
      <div [ngClass]="rangeStartInputClasses">
        <button
          [attr.aria-controls]="'date-picker-' + id"
          [disabled]="disabled"
          aria-haspopup="true"
          type="button"
          class="button button--icon button--icon-transparent date-picker__calendar-icon-container"
          (mousedown)="mousedown()"
          (click)="rangeCalendarIconClick(inputModes.start, $event)"
        >
          <div class="date-picker__calendar-icon" [ngClass]="{ 'date-picker__calendar-icon--disabled': disabled }">
            <svg-icon
              name="ico-calendar-16"
              [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
              [ngStyle]="{ height: '16px' }"
            >
            </svg-icon>
          </div>
        </button>
        <input
          #startDateInput
          type="text"
          [placeholder]="placeholder || format"
          class="textbox"
          [class.date-picker__active-input]="inputMode === inputModes.start && !inline"
          tabindex="1"
          [attr.name]="'datepicker-start-' + id"
          [disabled]="disabled"
          [attr.aria-invalid]="startError"
          [(ngModel)]="startInput"
          (ngModelChange)="parseValue(inputModes.start)"
          (blur)="parseRangeInput(inputModes.start)"
          (keyup.enter)="parseRangeInput(inputModes.start)"
        />
      </div>
    </div>

    <div [ngClass]="rangeEndClasses" [class.date-picker__fixed-width]="inline">
      <!-- Label goes here-->
      <ng-container *ngIf="endDateLabel">
        <span class="text-14">
          {{ endDateLabel | translate }}
        </span>
      </ng-container>
      <div [ngClass]="rangeEndInputClasses">
        <button
          [attr.aria-controls]="'date-picker-' + id"
          [disabled]="disabled"
          aria-haspopup="true"
          type="button"
          class="button button--icon button--icon-transparent date-picker__calendar-icon-container"
          (mousedown)="mousedown()"
          (click)="rangeCalendarIconClick(inputModes.end, $event)"
        >
          <div class="date-picker__calendar-icon" [ngClass]="{ 'date-picker__calendar-icon--disabled': disabled }">
            <svg-icon
              name="ico-calendar-16"
              [svgStyle]="{ 'width.px': 16, 'height.px': 16, fill: 'currentColor' }"
              [ngStyle]="{ height: '16px' }"
            >
            </svg-icon>
          </div>
        </button>
        <input
          type="text"
          [placeholder]="placeholder || format"
          class="textbox"
          [class.date-picker__active-input]="inputMode === inputModes.end && !inline"
          tabindex="2"
          [attr.name]="'datepicker-end-' + id"
          [disabled]="disabled"
          [attr.aria-invalid]="endError"
          [(ngModel)]="endInput"
          (ngModelChange)="parseValue(inputModes.end)"
          (blur)="parseRangeInput(inputModes.end)"
          (keyup.enter)="parseRangeInput(inputModes.end)"
        />
      </div>
    </div>
  </div>

  <ng-container
    *ngIf="inline && !rangeMode"
    [ngTemplateOutlet]="datepickerWidget"
    [ngTemplateOutletContext]="{
      current: current,
      inputMode: inputModes.value,
      yearsGrid: yearsGrid,
      monthsGrid: monthsGrid,
      daysGrid: daysGrid,
      view: view
    }"
  ></ng-container>

  <div *ngIf="inline && rangeMode" class="date-picker__range-inline">
    <div class="date-picker__range-start-input date-picker__fixed-width">
      <ng-container
        [ngTemplateOutlet]="datepickerWidget"
        [ngTemplateOutletContext]="{
          current: startCurrent,
          inputMode: inputModes.start,
          yearsGrid: startYearsGrid,
          monthsGrid: startMonthsGrid,
          daysGrid: startDaysGrid,
          view: startView
        }"
      ></ng-container>
    </div>
    <div class="date-picker__range-end-input date-picker__fixed-width">
      <ng-container
        [ngTemplateOutlet]="datepickerWidget"
        [ngTemplateOutletContext]="{
          current: endCurrent,
          inputMode: inputModes.end,
          yearsGrid: endYearsGrid,
          monthsGrid: endMonthsGrid,
          daysGrid: endDaysGrid,
          view: endView
        }"
      ></ng-container>
    </div>
  </div>

  <ng-container *ngIf="instructionalText">
    <div class="form__info-text no-select" [class.form__info-text__disabled]="disabled">
      {{ instructionalText | translate }}
    </div>
  </ng-container>

  <ng-container *ngIf="!disabled && (error || startError || endError)">
    <div role="alert" class="form__error-text">
      <div class="flex flex--row flex--middle">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" class="svg-icon icon">
          <g>
            <path d="M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Z" fill="currentColor"/>
            <path
              d="M9,13H7V11H9ZM9,8A.94.94,0,0,1,8,9,.94.94,0,0,1,7,8V4A.94.94,0,0,1,8,3,.94.94,0,0,1,9,4Z"
              fill="#fff"
            />
          </g>
        </svg>
        <span class="u-ml----">
          {{ 'vg.invalidEntry' | translate }}
        </span>
      </div>
    </div>
  </ng-container>

  <wfm-dropdown *ngIf="!inline" [adjustVerticalOverflow]="true" [disabled]="disabled"
                [(isOpen)]="isOpen" (isOpenChange)="isOpenChange($event)">
    <ng-container
      *ngIf="isOpen"
      [ngTemplateOutlet]="datepickerWidget"
      [ngTemplateOutletContext]="{
        current: current,
        inputMode: undefined,
        yearsGrid: yearsGrid,
        monthsGrid: monthsGrid,
        daysGrid: daysGrid,
        view: view
      }"
    ></ng-container>
  </wfm-dropdown>
</div>

<!-- Datepicker dropdown content -->
<ng-template
  #datepickerWidget
  let-current="current"
  let-inputMode="inputMode"
  let-yearsGrid="yearsGrid"
  let-monthsGrid="monthsGrid"
  let-daysGrid="daysGrid"
  let-view="view"
>
  <div
    [id]="'date-picker-' + id"
    class="date-picker__container date-picker__fixed-width"
    [class.date-picker__fixed-width]="!autoWidth"
    [class.inline]="inline"
  >
    <div class="date-picker__inner-container">
      <div class="date-picker__calendar-control">
        <button
          class="date-picker__calendar-control-arrow-container"
          [disabled]="isLeftArrowDisabled(inputMode)"
          (click)="goLeft(inputMode); click($event)"
        >
          <span class="date-picker__calendar-control-button-content">
            <svg-icon
              name="ico-caret-left-16"
              [svgStyle]="{ 'width.px': 16, 'height.px': 16 }"
              [ngStyle]="{ height: '16px' }"
            >
            </svg-icon>
          </span>
        </button>
        <button
          class="date-picker__calendar-control-arrow-container date-picker__calendar-control-content"
          (click)="goUp(inputMode); click($event)"
        >
          <span
            class="date-picker__calendar-control-period-container date-picker__calendar-control-button-content"
            style="width: 100%"
          >
            <span *ngIf="view === 'month'">{{ months[current.month()] }} &nbsp;</span>
            <span *ngIf="['month', 'year'].indexOf(view) >= 0"> {{ current.format('YYYY') }}</span>
            <span *ngIf="view === 'years'">
              {{ yearsGrid[0].label }} - {{ yearsGrid[yearsGrid.length - 1].label }}
            </span>
          </span>
        </button>
        <button
          class="date-picker__calendar-control-arrow-container"
          [disabled]="isRightArrowDisabled(inputMode)"
          (click)="goRight(inputMode); click($event)"
        >
          <span class="date-picker__calendar-control-button-content">
            <svg-icon
              name="ico-caret-right-16"
              [svgStyle]="{ 'width.px': 16, 'height.px': 16 }"
              [ngStyle]="{ height: '16px' }"
            >
            </svg-icon>
          </span>
        </button>
      </div>

      <div class="date-picker__calendar-container">
        <div class="date-picker__calendar-inner-container">
          <wfm-select-grid
            *ngIf="view === 'years'"
            [stopPropagation]="true"
            [columns]="4"
            [options]="yearsGrid"
            (optionClick)="yearClick($event, inputMode)"
          >
          </wfm-select-grid>

          <wfm-select-grid
            *ngIf="view === 'year'"
            [stopPropagation]="true"
            [columns]="4"
            [options]="monthsGrid"
            (optionClick)="monthClick($event, inputMode)"
          >
          </wfm-select-grid>

          <wfm-select-grid
            *ngIf="view === 'month'"
            [stopPropagation]="true"
            [columnsLabels]="weekdaysMin"
            [options]="daysGrid"
            (optionClick)="dayClick($event, inputMode)"
          >
          </wfm-select-grid>
        </div>
      </div>
    </div>
  </div>
</ng-template>
